import { t } from '@/locale/index.js'

/** 按 field 刷新 hc-search 表单项 label / placeholder */
export function applySearchLabels(searchData, fieldMap) {
  if (!searchData?.length || !fieldMap) return
  searchData.forEach((item) => {
    const m = fieldMap[item.field]
    if (!m) return
    if (m.labelKey) item.label = t(m.labelKey)
    if (m.placeholderKey) item.placeholder = t(m.placeholderKey)
  })
}

/** 按 prop 刷新表格列 label */
export function applyColumnLabels(columns, propKeyMap) {
  columns?.forEach((col) => {
    if (col.type === 'index') {
      col.label = t('table.index')
      return
    }
    const key = propKeyMap[col.prop]
    if (key) col.label = t(key)
  })
}

/** 刷新 select options 的 label */
export function applyOptionLabels(options, valueKeyMap) {
  options?.forEach((opt) => {
    const key = valueKeyMap[opt.value]
    if (key) opt.label = t(key)
  })
}
